module.exports = __webpack_public_path__ + "img/uptrend.8e1e3e88.svg";